import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { initialState, ProductsImportState, PRODUCTS_IMPORT_SLICE_NAME } from './models';
import { getImportsList, getProductsImportTemplate, importProducts } from './actionCreators';

export const slice = createSlice({
  name: PRODUCTS_IMPORT_SLICE_NAME,
  initialState,
  reducers: {
    setImportsFilters(state, action) {
      state.importsFilters = { ...state.importsFilters, ...action.payload };
    },
    resetProductsImportState() {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductsImportTemplate.fulfilled, (state: ProductsImportState) => {
        state.isLoading = false;
      })
      .addCase(getImportsList.fulfilled, (state: ProductsImportState, action) => {
        state.isLoading = false;
        state.importsList = action.payload;
      })
      .addMatcher(isPending(getProductsImportTemplate, getImportsList), (state: ProductsImportState) => {
        state.isLoading = true;
      })

      .addMatcher(
        isRejected(getProductsImportTemplate, getImportsList, importProducts),
        (state: ProductsImportState, action) => {
          const { error } = action;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetProductsImportState, setImportsFilters } = slice.actions;

export default slice.reducer;
